var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3671_10347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 8.00012C11.3141 8.00012 10.2967 8.42155 9.54657 9.17169C8.79643 9.92184 8.375 10.9393 8.375 12.0001C8.375 13.061 8.79643 14.0784 9.54657 14.8285C10.2967 15.5787 11.3141 16.0001 12.375 16.0001C13.4359 16.0001 14.4533 15.5787 15.2034 14.8285C15.9536 14.0784 16.375 13.061 16.375 12.0001C16.375 10.9393 15.9536 9.92184 15.2034 9.17169C14.4533 8.42155 13.4359 8.00012 12.375 8.00012Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.575 0C5.66544 0 3.83409 0.758569 2.48383 2.10883C1.13357 3.45909 0.375 5.29044 0.375 7.2L0.375 16.8C0.375 18.7096 1.13357 20.5409 2.48383 21.8912C3.83409 23.2414 5.66544 24 7.575 24H17.175C19.0846 24 20.9159 23.2414 22.2662 21.8912C23.6164 20.5409 24.375 18.7096 24.375 16.8V7.2C24.375 5.29044 23.6164 3.45909 22.2662 2.10883C20.9159 0.758569 19.0846 0 17.175 0L7.575 0ZM6.775 12C6.775 10.5148 7.365 9.09041 8.4152 8.0402C9.46541 6.99 10.8898 6.4 12.375 6.4C13.8602 6.4 15.2846 6.99 16.3348 8.0402C17.385 9.09041 17.975 10.5148 17.975 12C17.975 13.4852 17.385 14.9096 16.3348 15.9598C15.2846 17.01 13.8602 17.6 12.375 17.6C10.8898 17.6 9.46541 17.01 8.4152 15.9598C7.365 14.9096 6.775 13.4852 6.775 12ZM17.975 6.4H19.575V4.8H17.975V6.4Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3671_10347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f60b9511.svg";
export { ForwardRef as ReactComponent };